'use client'
import { useState, useEffect } from "react";

export const InboxItemsList = ({ data }) => {
    const [open, setOpen] = useState(false);
    const { title, list } = data || {};

    useEffect(() => {
        if (window.innerWidth >= 1024) setOpen(true);
    }, []);

    if (!list || list.length === 0) return null;

    return (
        <div style={{
            borderRadius: '12px',
            overflow: 'hidden',
            border: '1.5px solid var(--primary-color)',
            boxShadow: '0 4px 16px rgba(11,49,99,0.10)',
        }}>
            {/* ── Header ── */}
            <button
                onClick={() => setOpen((o) => !o)}
                style={{
                    width: '100%',
                    background: 'var(--primary-color)',
                    border: 'none',
                    padding: '0.55rem 1rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    cursor: 'pointer',
                    transition: 'opacity 0.15s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <i className="pi pi-box" style={{ color: 'var(--secondary-color)', fontSize: '0.85rem' }} />
                    <span style={{ color: '#fff', fontWeight: 700, fontSize: '0.85rem' }}>
                        {title || "What's in the Box?"}
                    </span>
                    <span style={{
                        fontSize: '0.65rem', fontWeight: 700,
                        background: 'rgba(255,255,255,0.18)', color: '#fff',
                        padding: '0.1rem 0.45rem', borderRadius: '999px',
                        border: '1px solid rgba(255,255,255,0.25)',
                    }}>
                        {list.length} item{list.length !== 1 ? 's' : ''}
                    </span>
                </div>
                <i
                    className={`pi ${open ? 'pi-chevron-up' : 'pi-chevron-down'}`}
                    style={{ color: '#fff', fontSize: '0.75rem', transition: 'transform 0.2s' }}
                />
            </button>

            {/* ── Items grid ── */}
            {open && (
                <div className="grid grid-nogutter" style={{ padding: '0.5rem', background: '#fff' }}>
                    {list.map((item, i) => (
                        <div key={i} className="col-12 lg:col-6 p-2">
                            <div style={{
                                display: 'flex', alignItems: 'center', gap: '0.55rem',
                                background: 'rgba(11,49,99,0.03)',
                                border: '1px solid rgba(11,49,99,0.12)',
                                borderRadius: '8px',
                                padding: '0.5rem 0.65rem',
                                height: '100%',
                            }}>
                                <span style={{
                                    width: '1.4rem', height: '1.4rem', borderRadius: '50%',
                                    background: 'var(--secondary-color)',
                                    flexShrink: 0,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    <i className="pi pi-check" style={{ fontSize: '0.55rem', color: '#fff', fontWeight: 800 }} />
                                </span>
                                <span style={{ fontSize: '0.75rem', color: 'var(--primary-color)', lineHeight: '1.35', fontWeight: 500 }}>
                                    {item}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
